export class TempAuthRequest
{
    partyName: string;
    partyType: string;
    tempAuthToken: string;
    expirationDateTime: string;
    partyId: number;
}